import { Component } from '@angular/core';

@Component({
    selector: 'ui-panel-docs-preview',
    templateUrl: './panel.docs.preview.html',
    styleUrls: ['./panel.docs.preview.scss'],
})
export class UIPanelDocsPreview {
}
